import { INJECT_APP } from "../helpers/symbols.js";
import { inject } from "#imports";
export function useBlokkli() {
  const app = inject(INJECT_APP);
  if (!app) {
    throw new Error(
      "The useBlokkli composable was called while not in edit mode."
    );
  }
  return app;
}
